export interface TableField {
  id: number;
  fieldId?: number;
  fieldIdentifier?: string;
  displayName: string;
  sortingIndex: number;
  group: boolean;
  parentId: number | null;
  value1?: any;
  value2?: any;
  isDeleted?: boolean;
  fields?: TableField[];
}

export interface Table {
  id: number;
  title: string;
  isDefault: boolean;
  owner: string;
  isDeleted: boolean;
  structure: TableField[];
  users: TableUser[];
  filters: TableFilter[];
  /** Only populated by GetDynamicTableList (the lightweight table-switcher list); true when more than one user has access. */
  isShared?: boolean;
  canEdit?: boolean;
}

export interface TableUser {
  id: number;
  email: string;
  canEdit: boolean;
}
export interface TableFilter {
  id: number;
  type: string;
  value: any[];
}

export interface FieldTypeConfig {
  name: string;
  fieldIdentifier: string;
  contextConfig: {
    value1?: {
      type: "text" | "select" | "tasks";
      label?: string;
      options?: { id: string; name: string }[];
      lookup?: string;
      required?: boolean;
    };
    value2?: {
      type: "text" | "select" | "tasks";
      label?: string;
      options?: { id: string; name: string }[];
      lookup?: string;
      required?: boolean;
    };
  };
}

export const fields: FieldTypeConfig[] = [
  {
    fieldIdentifier: "projectId",
    name: "Project Id",
    contextConfig: {}, // No additional context
  },
  {
    fieldIdentifier: "departmentAssignee",
    name: "Department Assignee",
    contextConfig: {
      value1: {
        type: "select",
        label: $localize`:@@Department:Department`,
        options: [],
        lookup: "departments",
        required: true,
      },
    },
  },
  {
    fieldIdentifier: "milestoneDueDate",
    name: "Milestone Due Date",
    contextConfig: {
      value1: {
        type: "select",
        label: $localize`:@@Milestone:Milestone`,
        options: [],
        lookup: "milestone",
        required: true,
      },
    },
  },
  {
    fieldIdentifier: "milestoneCompletionDate",
    name: "Milestone Completion Date",
    contextConfig: {
      value1: {
        type: "select",
        label: $localize`:@@Milestone:Milestone`,
        options: [],
        lookup: "milestone",
        required: true,
      },
    },
  },
  {
    fieldIdentifier: "taskResult",
    name: "Task Result",
    contextConfig: {
      value1: {
        type: "tasks",
        label: $localize`:@@Task:Task`,
        options: [],
        lookup: "tasks",
        required: true,
      },
    },
  },
  {
    fieldIdentifier: "taskStatus",
    name: "Task Status",
    contextConfig: {
      value1: {
        type: "tasks",
        label: $localize`:@@Task:Task`,
        options: [],
        lookup: "tasks",
        required: true,
      },
    },
  },
  {
    fieldIdentifier: "taskAssignee",
    name: "Task Assignee",
    contextConfig: {
      value1: {
        type: "tasks",
        label: $localize`:@@Task:Task`,
        options: [],
        lookup: "tasks",
        required: true,
      },
    },
  },
  {
    fieldIdentifier: "taskDueDate",
    name: "Task Due Date",
    contextConfig: {
      value1: {
        type: "tasks",
        label: $localize`:@@Task:Task`,
        options: [],
        lookup: "tasks",
        required: true,
      },
    },
  },
];

export interface GroupedStructure {
  groupName: string;
  fields: TableField[];
}

export interface EditTable {
  id: number;
  title: string;
  users: TableUser[];
  filters: TableFilter[];
  structure: EditTableField[];
}

export interface EditTableField {
  id: number;
  fieldId?: number;
  fieldIdentifier?: string;
  name: string;
  sortingIndex: number;
  group: boolean;
  value1?: any;
  value2?: any;
  isDeleted?: boolean;
  fields?: EditTableField[];
  fieldConfig?: FieldTypeConfig | null;
}
